import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadCrumb } from '../contracts/breadcrumb-interface';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbSharedService {
    private breadcrumbDataSource = new BehaviorSubject<any>('DEFAULT_MESSAGE');
    currentBreadcrumbData = this.breadcrumbDataSource.asObservable();
    breadCrumbImageEvent: EventEmitter<any> = new EventEmitter();
    userScrollEvent: EventEmitter<any> = new EventEmitter<any>();

    public static breadcrumbStaticDataSource = new BehaviorSubject<any>('DEFAULT_MESSAGE');
    public static currentStaticBreadcrumbData = BreadcrumbSharedService.breadcrumbStaticDataSource.asObservable();

    public static changeStaticBreadcrumbData(data: BreadCrumb) {
        BreadcrumbSharedService.breadcrumbStaticDataSource.next(data);
    }

    changeBreadcrumbData(data: any) {
        this.breadcrumbDataSource.next(data);
    }

    changeBreadcrumbImage(imageSource) {
        this.breadCrumbImageEvent.emit(imageSource);
    }

    getBreadcrumbImage() {
        return this.breadCrumbImageEvent;
    }

    sendUserScrollEvent(scrollData: any) {
        this.userScrollEvent.emit(scrollData);
    }

    getUserScrollEvent() {
        return this.userScrollEvent;
    }
}
